"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const moment = require("moment");
const images_1 = require("@dialogexe/cw-asset-provider/images");
require("moment/locale/nn");
require("moment/locale/nb");
const SPACE = `\u00A0`;
const NORMAL = "normal";
const OPEN = "open";
const MIN_SPOTS = 10; //percent
class LandScapeCard extends React.Component {
    constructor(props) {
        super(props);
        this.getMinMaxDate = () => {
            const tickets = this.props.tickets;
            if (tickets.length > 0) {
                const dates = tickets.map(t => moment(t.date).startOf('day').unix());
                const min = Math.min(...dates);
                const max = Math.max(...dates);
                return { min, max };
            }
            return { min: null, max: null };
        };
        this.getMinTicketCount = (ticket) => {
            return ticket.count * (MIN_SPOTS / 100);
        };
        this.hasFewSpots = () => {
            const { tickets } = this.props;
            return tickets.every(ticket => ticket.ticketSaleType === NORMAL && ticket.count <= this.getMinTicketCount(ticket));
        };
        this.isSalesNotEnabled = () => {
            const { tickets } = this.props;
            return tickets.every(ticket => ticket.salesEnabled === false);
        };
        this.isSoldOut = () => {
            const { tickets } = this.props;
            return tickets.every(ticket => ticket.count <= 0 && ticket.ticketSaleType === NORMAL);
        };
        this.isOpenArrangement = () => {
            const { tickets } = this.props;
            return tickets.every(ticket => ticket.ticketSaleType === OPEN);
        };
        this.renderTicketButton = (ticket, link) => {
            const { preferredLanguage } = this.props;
            const buyTicketLable = preferredLanguage === 'nn' ? "Kjøp billett" : "Kjøp billett";
            const soldOut = preferredLanguage === 'nn' ? "Utseld" : "Utsolgt";
            if (this.isSalesNotEnabled()) {
                return (React.createElement("button", { className: "landscapeCard-no-sale" }, " Salg ikke \u00E5pnet "));
            }
            if (this.isSoldOut()) {
                return (React.createElement("button", { className: "landscapeCard-sold-out-button" },
                    " ",
                    soldOut,
                    " "));
            }
            if (this.isOpenArrangement()) {
                return (React.createElement("button", { className: "landscapeCard-no-sale" }, " Gratis arrangement "));
            }
            if (this.hasFewSpots()) {
                return (React.createElement("button", { className: "landscapeCard-few-sale-button" }, " F\u00E5 ledige "));
            }
            if (ticket && (ticket.purchaseUrl || ticket.link)) {
                const ticketUrl = ticket.purchaseUrl ? ticket.purchaseUrl : ticket.link;
                return (React.createElement("a", { className: "landscapeCard-sale-button", href: ticketUrl },
                    buyTicketLable,
                    " "));
            }
            if (link) {
                return (React.createElement("a", { className: "landscapeCard-sale-button", href: link },
                    buyTicketLable,
                    " "));
            }
        };
        this.renderLinkTicket = (link) => {
            const { preferredLanguage } = this.props;
            const linkToBuyTicket = preferredLanguage === 'nn' ? "Fleire visningar" : "Flere oppsatte forestillinger";
            return (React.createElement("a", { href: `${link}/#tickets` },
                " ",
                linkToBuyTicket,
                " "));
        };
        this.capitalizeFirstLetter = (text) => {
            return text.charAt(0).toLocaleUpperCase() + text.slice(1);
        };
        const preferredLanguage = props.preferredLanguage ? props.preferredLanguage : 'nb';
        moment.locale(preferredLanguage);
    }
    render() {
        const { image, title, link, tickets, preferredLanguage } = this.props;
        const { min, max } = this.getMinMaxDate();
        const count = tickets.length;
        const ticket = count === 1 ? tickets[0] : null;
        const day = this.capitalizeFirstLetter(moment.unix(min).format("dddd"));
        return (React.createElement("div", { className: "LandscapeCard" },
            React.createElement("div", { className: "landscapeCard-image" },
                React.createElement("a", { href: link },
                    React.createElement("img", { src: image ? image : images_1.landscapeImagePlaceholder }))),
            React.createElement("div", { className: "landscapeCard-period" },
                (count === 1 || min === max) &&
                    React.createElement("div", { className: "landscapeCard-period  landscapeCard-period-single" },
                        day,
                        "  ",
                        moment.unix(min).format("D. MMMM")),
                (count > 1 && min != max) &&
                    React.createElement("div", { className: "landscapeCard-period  landscapeCard-period-multi" }, ` ${this.getBeginDate(min)} - ${this.getEndDate(max)}`)),
            React.createElement("div", { className: "landscapeCard-title-sale-link" },
                title && (React.createElement("div", { className: `landscapeCard-title` },
                    React.createElement("a", { href: link }, title))),
                React.createElement("div", { className: "landscapeCard-sale-parent" }, this.renderTicketButton(ticket, link))),
            ticket &&
                React.createElement("div", { className: "landscapeCards-period-location" },
                    React.createElement("div", { className: "begin" },
                        React.createElement("div", null, "Start"),
                        React.createElement("div", null, this.getBeginTime(ticket.date))),
                    React.createElement("div", { className: "end" },
                        React.createElement("div", null, "Slutt"),
                        React.createElement("div", null, this.getEndTime(ticket.end))),
                    React.createElement("div", { className: "location" },
                        React.createElement("div", null, "Sal/Scene"),
                        React.createElement("div", null, ticket.location))),
            count > 1 &&
                React.createElement("div", { className: "landscapeCard-link-to-ticket" }, this.renderLinkTicket(link))));
    }
    getBeginTime(date) {
        return moment(date).format('HH:mm');
    }
    getEndTime(date) {
        return moment(date).format('HH:mm');
    }
    getBeginDate(min) {
        const day = this.capitalizeFirstLetter(moment.unix(min).format('dddd'));
        return day + " " + moment.unix(min).format('D. MMMM');
    }
    getEndDate(max) {
        const day = this.capitalizeFirstLetter(moment.unix(max).format('dddd'));
        return day + " " + moment.unix(max).format('D. MMMM');
    }
}
exports.LandScapeCard = LandScapeCard;
exports.default = LandScapeCard;



// WEBPACK FOOTER //
// ./~/@dialogexe/cw-component-culture-program/~/@dialogexe/cw-component-landscape-card/LandScapeCard.tsx